import React, { useState } from 'react'
import ShopHeader from './ShopHeader'
import { setData } from './Med';


const Plants = () => {

    const [count, setCount] = useState(0)

    const add = (obj) => {
        setData(obj)
        setCount(count + 1)
    }

    return (
        <>
            <ShopHeader cartCount={count} />
            <i><h1 className='h1t'>PLANTS & AQUA ANIMALS</h1></i>

            <div className='row'>
                {itemData.map((items, index) => {
                    return (
                        <div class="card cardstyle">
                            <img class="card-img-top mt-2" src={items.img} alt="Card cap" />
                            <div class="card-body">
                                <h5 class="card-title">{items.title}</h5>
                                <button onClick={() => add(items)} class="btn btn-primary">Add To Cart</button>
                            </div>
                        </div>
                    )
                })}

            </div>
        </>
    )
}
const itemData = [
    {
        img: 'https://images.unsplash.com/photo-1518756131217-31eb79b20e8f',
        title: 'Fern',
    },
    {
        img: 'https://images.unsplash.com/photo-1597645587822-e99fa5d45d25',
        title: 'Mushrooms',
        rows: 2,
        cols: 2,
    },
    {
        img: 'https://images.unsplash.com/photo-1567306301408-9b74779a11af',
        title: 'Tomato basil',
    },
    {
        img: 'https://images.unsplash.com/photo-1471357674240-e1a485acb3e1',
        title: 'Sea star',
    },
];

export default Plants